/**
 * RESPONSIBILITY: which slice of the one events list the Children's page shows.
 *
 * The events themselves are entered once, on the Events section. This band says which
 * tag to draw from — so nobody types an event twice and the two can never disagree.
 *
 * No @EditableBy, so WRITE defaults to NONE — admin only.
 */
import { Section, Text, Num, Link } from '@framework/core/decorators';
import { SectionName } from '../section-names';
import { COUNT_HINT, LINK_HINT } from '../hints';

@Section({ name: SectionName.ChildrenEvents, label: 'Children — events band' })
export class ChildrenEventsSection {
  @Text({ label: 'Title', maxLength: 300, default: 'Upcoming' })
  eventsHeading!: string;

  @Text({ label: 'Button text', maxLength: 120, default: 'All events', group: 'Button' })
  allEventsLabel!: string;

  @Link({ label: 'Button link', group: 'Button', description: LINK_HINT })
  allEventsHref!: string;

  /**
   * Plain text, not a @Choice: the categories live on the events section and `in`
   * resolves within one section. A name matching nothing shows no events, which is
   * visible and harmless.
   */
  @Text({
    label: 'Show this tag', maxLength: 120,
    description: 'Must match a tag on the Events section. e.g. Children',
  })
  eventCategory!: string;

  @Num({
    label: 'How many to show', min: 1, max: 12, integer: true, default: 3,
    description: COUNT_HINT,
  })
  count!: number;
}
